import { tv } from 'tailwind-variants'

export const statusTag = tv({
  base: 'px-mega py-micro w-[118px] rounded-mili flex items-center justify-center',
  variants: {
    status: {
      ERROR: 'bg-error-medium',
      RECEIVED: 'bg-success-medium',
      PROCESSING: 'bg-info-medium'
    }
  }
})
